import { render } from "./Contacts.vue?vue&type=template&id=12b931e0&scoped=true"
import script from "./Contacts.vue?vue&type=script&lang=ts"
export * from "./Contacts.vue?vue&type=script&lang=ts"

import "./Contacts.vue?vue&type=style&index=0&id=12b931e0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-12b931e0"

export default script